<template>
	<div class="deal_refund_box">
		<!-- 交易數據 -->
		<div class="deal_title">
			<div>交易數據</div>
			<div class="deal_hr">
				<div class="cut_off"></div>
			</div>
		</div>
		<!-- BOX-go -->
		<div>
			<!-- 内容-實時交易數據 -->
			<div class="deal_content_box">
				<div class="deal_content_title">實時交易數據</div>
				<div class="deal_content">
					<div class="content_auto_box">
						<div class="remind_box">
							<i class="el-icon-warning icon_warning"></i>
							本頁面資料僅供經營狀況參考，不記退款，不代表帳單資訊，請勿用作對帳。
						</div>
						<!-- 1-累計數據和趨勢 -->
						<div class="content_title">累計數據和趨勢</div>
						<div class="market_box">
							<div class="market_content" @click="screenline(0)">
								<p class="market_title">最近24小時銷售金額</p>
								<p class="market_number">{{mosne}}</p>
								<p class="market_time">對比前24小時</p>
							</div>
							<div class="market_content" @click="screenline(1)">
								<p class="market_title">最近24小時銷售筆數</p>
								<p class="market_number">{{mosne1}}</p>
								<p class="market_time">對比前24小時</p>
							</div>
							<div class="market_content" @click="screenline(2)">
								<p class="market_title">最近24小時人均金額</p>
								<p class="market_number">{{mosne2}}</p>
								<p class="market_time">對比前24小時</p>
							</div>
						</div>
						<div class="data_form_box">
							<div id="myChart" :style="{width: '70%', height: '400px'}"></div>
						</div>

						<!-- 2-詳細數據 -->
						<div class="content_title_2">詳細數據</div>
						<div class="detail_box">
							<div class="detail_content_box" v-for="item of obser" :key="">
								<p>{{item.time}}</p>
								<p>{{item.money}}</p>
								<p>{{item.count}}</p>
								<p>{{item.pj}}</p>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- BOX-end -->
		</div>
		<!-- deal_refund_box -->
	</div>
</template>

<script>
	import axios from 'axios';
	export default {
		name: 'LoginDataRealTime',
		data() {
			return {
				// 折线图
				listmoney: 1,
				datazxt: '',
				mosne: '',
				mosne1: '',
				mosne2: '',
				obser: [],
				dataList: [{
						id: '001',
						dataTime: '2019-02-10',
						time: '21:00-22:00',
						number: '0',
						number2: '0.00'
					},
					{
						id: '002',
						dataTime: '2019-02-10',
						time: '20:00-21:00',
						number: '0',
						number2: '0.00'
					},
					{
						id: '003',
						dataTime: '2019-02-10',
						time: '19:00-20:00',
						number: '0',
						number2: '0.00'
					},
					{
						id: '004',
						dataTime: '2019-02-10',
						time: '18:00-19:00',
						number: '0',
						number2: '0.00'
					},
					{
						id: '005',
						dataTime: '2019-02-10',
						time: '17:00-18:00',
						number: '0',
						number2: '0.00'
					},
					{
						id: '006',
						dataTime: '2019-02-10',
						time: '16:00-17:00',
						number: '0',
						number2: '0.00'
					}
				]
			}
		},
		mounted() {
			this.drawLine();
		},
		methods: {
			screenline(e) {
				var myChart = this.$echarts.init(document.getElementById('myChart'))
				var list;
				if (e == 0) {
					list = '销售金额'
				} else if (e == 1) {
					list = '銷售筆數'
				} else {
					list = '人均金額'
				}
				myChart.setOption({
					xAxis: {
						data: this.datazxt[e].time
					},
					series: [{
						// 根据名字对应到相应的系列
						name: list,
						data: this.datazxt[e].num
					}]
				});
			},
			drawLine() {
				// 基于准备好的dom，初始化echarts实例
				var myChart = this.$echarts.init(document.getElementById('myChart'))
				// 绘制图表
				myChart.setOption({
					title: {
						text: '',
						subtext: ''
					},
					grid: {
						x: 45,
						y: 65,
						x2: 55,
						y2: 50,
						borderWidth: 1
					},

					tooltip: {
						trigger: 'axis'
					},
					legend: {
						data: ['销售金额', '銷售筆數', '人均金額']

					},
					toolbox: {
						show: true,
					},
					xAxis: {
						splitLine: {
							show: true
						},
						type: 'category',
						boundaryGap: false,
						data: ['2019-07-5', '2019-07-6', '2019-07-7', '2019-07-8', '2019-07-9', '2019-07-10', '2019-07-11'],
						axisLabel: {
							show: true,
							textStyle: {
								color: '#000' //x轴data 的颜色
							}
						},
						axisLine: {
							lineStyle: {
								color: '#e7e7eb', //x轴颜色 
							}
						}
					},
					yAxis: {
						type: 'value',
						axisLabel: {
							formatter: '{value}筆 '
						},
						axisLabel: {
							show: true,
							textStyle: {
								color: '#000' //x轴data 的颜色
							}
						},
						axisLine: {
							lineStyle: {
								color: '#e7e7eb', //x轴颜色 
							}
						}
					},
					series: [{
						color: 'rgba(109, 218, 109, 1)',
						symbolSize: 5,
						width: 3,
						name: '交易筆數',
						type: 'line',
						data: [0, 11, 3, 13, 7, 13, 5],
						markPoint: {
							data: [{
									type: 'max',
									name: '交易筆數最大'
								},
								{
									type: 'min',
									name: '交易筆數最小'
								}
							]
						},
						markLine: {
							data: [{
								type: 'average',
								name: '平均值',
								symbol: 'circle',
							}]
						}
					}]
				})
			},
			amendAxFun() {
				axios.get(this.$store.state.axiosDatatimeurl, {
					params: {
						uid: this.$store.state.uid,
						// action: 1,
					}
				}).then((res) => {
					if (res.data.status) {
						this.datazxt = res.data.message;
						this.mosne = this.datazxt[0].top;
						this.mosne1 = this.datazxt[1].top;
						this.mosne2 = this.datazxt[2].top;
						this.obser = this.datazxt[3];
						// console.log(this.obser)
						var myChart = this.$echarts.init(document.getElementById('myChart'))

						myChart.setOption({
							xAxis: {
								data: res.data.message[0].time
							},
							series: [{
								// 根据名字对应到相应的系列
								name: '销售金额',
								data: res.data.message[0].num
							}]
						});
					} else {
						this.$message({
							showClose: true,
							message: res.data.message,
							type: 'error',
							duration: 1000
						});
					}

				})

			},

		},
		created() {
			this.amendAxFun();
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	/* 申請退款 */
	.icon_warning {
		font-size: 22px;
		color: #ff4a05;
		padding: 0 6px 0 24px;
	}

	.input_box {
		width: 100px;
	}

	.textarea_box {
		width: 350px;
		margin-left: 10px;
	}

	.input_pass {
		width: 350px;
	}

	.input_pass_number {
		margin-left: 10px;
		color: #4d80e7;
	}

	.el-input__inner {
		height: 20px;
	}

	.deal_refund_box {
		margin: 20px;
		font-size: 15px;
		color: black;
	}

	.deal_title {
		display: flex;
		justify-content: flex-start;
	}

	.deal_title span {
		margin-left: 15px;
		margin-right: 8px;
	}

	.deal_title .deal_hr {
		flex: 1;
		margin-left: 18px;
	}

	.deal_title .deal_hr .cut_off {
		height: 3px;
		background: black;
		margin-top: 8px;
	}

	/* 内容 */
	.remind_box {
		background: #fff4cc;
		color: black;
		width: 70%;
		min-width: 686px;
		height: 50px;
		display: flex;
		align-items: center;
		margin-bottom: 30px;
		margin-left: -6px;
	}

	.datetime_box>span {
		margin: 10px;
	}

	.deal_content_box {
		font-size: 13px;
		margin-top: 20px;
		min-width: 800px;
	}

	.deal_content_title {
		height: 42px;
		background: #666666;
		line-height: 42px;
		color: white;
		padding-left: 14px;
	}

	.deal_content {
		box-sizing: border-box;
		border: 1px solid #666666;
		background: #ffffff;
		color: #777777;
		padding: 5px 25px 30px 25px;
	}

	.content_auto_box {
		padding: 32px;
	}

	.content_title {
		color: black;
		font-size: 15px;
		font-weight: bold;
		padding-left: 8px;
		padding-right: 50px;
		line-height: 17px;
		border-left: 8px solid #e73262;
		margin-bottom: 22px;
	}

	.content_title_2 {
		color: black;
		font-size: 15px;
		font-weight: bold;
		padding-left: 8px;
		padding-right: 50px;
		line-height: 17px;
		border-left: 8px solid #e73262;
		margin: 24px 0 22px 0;
	}

	.content_title_p {
		width: 650px;
		line-height: 21px;
		margin-left: 15px;
	}

	.content_title_button {
		padding: 4px 8px;
		margin: 26px 0 30px 15px;
	}

	/* 累計數據和趨勢 */
	.market_box {
		width: 70%;
		display: flex;
		justify-content: space-around;
		color: black;
		min-width: 700px;
	}

	.market_content {
		display: flex;
		flex-direction: column;
		align-items: flex-end;
	}

	.market_title {
		font-size: 13px;
	}

	.market_number {
		font-size: 29px;
		font-weight: bold;
		color: #e73262;
		margin: 16px 0;
	}

	.market_time {
		font-size: 11px;
		color: #666666;
	}

	.data_form_box {
		margin: 20px 0;
	}

	.data_form_box>img {
		width: 100%;
		max-width: 924px;
	}

	/* 詳細數據 */
	.detail_box {
		display: flex;
		justify-content: space-around;
		flex-direction: column;
	}

	.detail_content_box {
		color: black;
		width: 750px;
		padding: 0 16px;
		display: flex;
		justify-content: space-between;
	}

	.detail_content_box>p {
		margin: 12px 0;
	}
</style>
